import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
//import LoginPage from '@/views/LoginPage';
//import SignupPage from '@/views/SignupPage';
import consoleRouter from '@/routes/console/consoleRouter';
import loginRouter from '@/routes/login/loginRouter';
import jobRouter from '@/routes/job/jobRouter';
import { getJson } from '@/api/network';
import { addTaskQueue } from '@/utils/util';
import { loadLocale } from '@/plugins/locales';

Vue.use(VueRouter);

// const requireAuth = () => (to, from, next) => {
//   if (store.state.token !== '') {
//     return next();
//   }
//   next('login/' + router.params.tenantKey);
// };

const router = new VueRouter({
  mode: 'history', //URL의 #이 제거 된다.
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'publish',
      path: '/publish',
      component: () => import('@/views/Publish.vue'),
    },
    {
      path: '/login/:tenantKey',
      //component: LoginPage,
      component: () => import('@/views/LoginPage.vue'),
      children: loginRouter,
      meta: {
        isLogin: true,
      },
    },
    {
      path: '/announces/:tenantKey',
      component: () => import('@/views/JobPage.vue'),
      children: jobRouter,
      //redirect: '/login',
    },
    {
      path: '/clear/:tenantKey',
      //component: LoginPage,
      meta: {
        isClear: true,
      },
    },
    {
      path: '/console/:tenantKey',
      component: () => import('@/views/CvPage.vue'),
      children: consoleRouter,
      meta: {
        auth: true,
      },
    },
    {
      path: '/itemTestPage/:tenantKey',
      component: () => import('@/views/ItemTestPage.vue'),
    },
    {
      path: '/testPage/:tenantKey',
      component: () => import('@/views/ChartPage.vue'),
    },
    {
      name: 'ReRender',
      path: `/ReRender`,
      component: () => import('@/views/ReRender.vue'),
    },
    {
      name: 'NotFound',
      path: '*',
      component: () => import('@/views/NotFoundPage.vue'),
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  await loadLocale();
  if (to.name == 'ReRender') {
    to.params.path = from.fullPath || '/';
    return next();
  }
  if (to.name == 'NotFound') {
    return next();
  }
  let tenantKey = null;

  if (
    to.name === 'jobPosting' ||
    to.name === 'jobPostingDetail' ||
    to.name == 'publish'
  ) {
    return next();
  }
  if (to.params.tenantKey != null && to.params.tenantKey != '') {
    tenantKey = to.params.tenantKey;
    store.commit('setTenant', tenantKey);
    if (!to.meta.isLogin) {
      if (store.dispatch('hasAuthorization', tenantKey)) {
        if (to.meta.auth && !store.getters.isLogin) {
          if (to.name === 'cv') {
            store.commit('setRedirectUrl', to.fullPath);
          }
          next('/login/' + tenantKey);
          return;
        }

        if (to.meta.isLogin && store.getters.isLogin) {
          next('/console/' + tenantKey);
          return;
        }

        if (to.meta.isClear) {
          store.dispatch('LOGOUT', tenantKey);
          return;
        }

        if (to.meta.auth && store.getters.redirectUrl !== '') {
          let redirectUrl = store.getters.redirectUrl;
          store.commit('clearRedirectUrl');
          next(redirectUrl);
          return;
        }
      }
    }
  }
  next();
});
let lastTenantkey;
router.afterEach(async to => {
  await addTaskQueue();
  if (!lastTenantkey || lastTenantkey != to.params.tenantKey) {
    getJson('api/' + to.params.tenantKey + '/image/fa', {})
      .then(res => {
        if (
          res &&
          res.data &&
          res.data.hasOwnProperty('image') &&
          res.data.image &&
          res.data.image != ''
        ) {
          const favicon = document.querySelector("link[rel='icon']");
          favicon.href = res.data.image;
          lastTenantkey = to.params.tenantKey;
        }
      })
      .catch(error => {
        console.log(error);
        lastTenantkey = '';
      });
  }
});

export default router;
